/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameActionPlusIcon16Solid = forwardRef('ScanFrameActionPlusIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12 1a3 3 0 0 1 3 3v1.5a1 1 0 1 1-2 0V4a1 1 0 0 0-1-1h-1.5a1 1 0 0 1 0-2H12Z" }),
        React.createElement("path", { d: "M1 12a3 3 0 0 0 3 3h1.5a1 1 0 1 0 0-2H4a1 1 0 0 1-1-1v-1.5a1 1 0 0 0-2 0V12Z" }),
        React.createElement("path", { d: "M15 12a3 3 0 0 1-3 3h-1.5a1 1 0 1 1 0-2H12a1 1 0 0 0 1-1v-1.5a1 1 0 1 1 2 0V12Z" }),
        React.createElement("path", { d: "M1 4a3 3 0 0 1 3-3h1.5a1 1 0 0 1 0 2H4a1 1 0 0 0-1 1v1.5a1 1 0 0 1-2 0V4Z" }),
        React.createElement("path", { d: "M9 5a1 1 0 1 0-2 0v2H5a1 1 0 0 0 0 2h2v2a1 1 0 1 0 2 0V9h2a1 1 0 1 0 0-2H9V5Z" })));
});
